import { render, staticRenderFns } from "./SignOffButton.vue?vue&type=template&id=254242b0"
import script from "./SignOffButton.vue?vue&type=script&lang=ts"
export * from "./SignOffButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports